// extracted by mini-css-extract-plugin
export default {"category_tab":"CategoryTab_category_tab__aP-su","category_tab_selected":"CategoryTab_category_tab_selected__MwS9v"};